import { BaseComponent } from '../../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../../components/Box';
import { VehicleCreateOrderField } from './Fields';
import { fetchCompany, toggleNotification } from '../../../../Companies/actions';
import { UserSelection } from '../../../../Users/components/UserSelectionComponent';
import { setNewOrderValue } from '../../../actions';
import { EditSquare, Check, CircleTimes } from '../../../../../components/Icon';
import { UserLabelById } from '../../../../Users/components/UserLabelById';
import { getPropByName } from '../../../../../utils/props';
import { CompanyQuickCreator } from '../../../../Companies/pages/QuickCreate/QuickCreate';
import { Modal, ModalControls } from '../../../../../components/Modal';
import { Notification } from '../../../../../components/Notification';
import { setNewInvoiceValue } from '../../../../Invoices/actions';
import { selectNewOrder } from '../../../selectors';
import { selectConfig, selectWorks } from '../../../../Api/selectors';
import { selectNotification } from '../../../../Companies/selectors';
import { selectNewInvoice } from '../../../../Invoices/selectors';
import { REQUEST_COMPANY_ADD_USER } from '../../../../Companies/constants';
import { REQUEST_USER } from '../../../../Users/constants';
import env from '../../../../../env';
import { isWithInstallation } from '../../../helpers';
import { WIENTJES_INSTALATION } from '../../../../../containers/App/constants';
import { AppClientId } from '../../../../Shared/constants';

import cn from 'classnames';
import ModalComponent from '../../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../../../containers/App/Components/Checkbox/Checkbox';
import NotificationComponent from '../../../../../containers/App/Components/Notification/Notification';
import styles from './SelectClientToOrderModal.module.css';
import { mapInvoiceToCopy } from '../../../../Invoices/helpers';

const Container = styled.div`
  .button-sync {
    margin: 0px;
  }
  visibility: ${props => (props.customerModal ? 'hidden' : '')};

  .message {
    max-width: 400px;
    margin: 10px 0;
  }
`;

const STATE = {
  selectUser: false,
  addUser: null,
  showCustomerModal: false,
};

/* eslint-disable react/prefer-stateless-function */
class SelectClientToOrderComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.copyFromInvoiceId) {
      Object.entries(mapInvoiceToCopy(this.props.copyFromInvoice, this.props.vehicle))?.map(value => {
        this.props.setValue(value[1], value[0]);
      });
    }

    if (env.clientId != AppClientId.AUTOWIENTJES) {
      this.props.setValue('1', 'includeFinancialContact');
      this.props.setValue('1', 'includeEmailContact');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.values?.outgoingCompanyId !== prevProps.values?.outgoingCompanyId) {
      this.props.fetchCompany(this.props.values?.outgoingCompanyId, result => {
        if (result?.id) {
          if (env.clientId === AppClientId.INDEWAL || env.clientId === AppClientId.IDWLEASE) {
            let email = getPropByName(result, 'company_email');
            const finContactId = getPropByName(result, 'relation_financial_contact_id');
            const finContactUser = (result.users ?? []).find(u => u.id == finContactId);
            if (finContactUser?.email_address) email = finContactUser.email_address;

            return this.setState({
              defaultFinContact: finContactId,
              outgoing_block: getPropByName(result, 'outgoing_block'),
              companyEmail: email,
            });
          } else {
            return this.setState({
              outgoing_block: getPropByName(result, 'outgoing_block'),
              companyEmail: getPropByName(result, 'company_email'),
            });
          }
        }
      });
    }

    if (this.props.notification?.isShow) {
      this._t = this.timeout(
        () => {
          this.props.toggleNotification();
        },
        5000,
        this._t,
      );
    }
  }

  selectUser(user) {
    this.props.setValue(user?.id, 'email_contact');
    this.reset();
  }

  reset() {
    this.setState({ selectUser: false, addUser: null });
  }

  onResetValues() {
    [
      'client',
      'email_contact',
      'financial_contact',
      'includeEmailContact',
      'includeFinancialContact',
      'includeManual',
      'outgoingCompanyId',
      'send_to_email',
    ].map(type => this.props.setValue('', type));
    return this.props.reset();
  }

  renderAddUser() {
    if (!this.state.selectUser) return null;
    return (
      <div className={styles.buttonGroup}>
        {this.state.addUser?.id ? (
          <div className={styles.input}>
            <input type="text" id="readOnlyInput" className="form-control" placeholder={this.state.addUser?.email_address} />
          </div>
        ) : (
          <UserSelection onSelect={user => this.setState({ addUser: user })} />
        )}
        <div className={styles.buttons}>
          <ButtonComponent
            style={'ButtonSoftPrimary'}
            disabled={!this.state.addUser?.id}
            onClick={() => this.selectUser(this.state.addUser)}
          >
            <Check />
          </ButtonComponent>

          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            <CircleTimes />
          </ButtonComponent>
        </div>
      </div>
    );
  }

  openCustomerModal() {
    this.setState({ showCustomerModal: true });
  }

  applyDisabled() {
    if (!this.props.values?.outgoingCompanyId) return true;
    const clientOptional = this.props?.serverConfig?.incomingContactOptional || env.hide_mandatory_field_outgoing_order;
    if (!this.props.values?.client && !clientOptional && env.clientId != AppClientId.AUTOWIENTJES) {
      return true;
    }
    if (this.state.outgoing_block === '1') return true;

    return false;
  }

  handleNextClick = () => {
    const { handleNext, onNextModal } = this.props;

    if (handleNext) {
      handleNext();
    }

    if (onNextModal) {
      onNextModal();
    }
  };

  render() {
    return (
      <>
        {this.state.showCustomerModal && (
          <CompanyQuickCreator outgoingModal resetQuickModal={() => this.setState({ showCustomerModal: false })} />
        )}
        <Container customerModal={this.state.showCustomerModal}>
          {this.props.notification?.isShow == '1' && (
            <NotificationComponent>{this.lbl(`company.create.${this.props.notification?.message}`)}</NotificationComponent>
          )}

          <ModalComponent onClose={this.props.reset} title={this.lblStr('vehicle.order.select_client')} size={'lg'}>
            <VBox>
              {['outgoingCompanyId'].map(type => (
                <VehicleCreateOrderField
                  invoicePage={this.props.invoicePage}
                  key={type}
                  type={type}
                  defaultFinancialContact={this.state.defaultFinContact}
                  showNewCompanyModal={this.openCustomerModal.bind(this)}
                />
              ))}

              {this.state.outgoing_block === '1' && (
                <div className="message">
                  <strong>{this.lbl('company.block_invoice_sorry')}</strong>
                </div>
              )}
              {['client', 'financial_contact']
                .filter(type => {
                  if (env.hide_mandatory_field_outgoing_order && type === 'client') return false;
                  return true;
                })
                .map(type => {
                  if (type == 'financial_contact') {
                    return (
                      <div className={styles.checkboxContainer}>
                        <div className={styles.checkbox}>
                          {/* <CheckboxComponent
                            checked={this.props.values?.includeFinancialContact === '1'}
                            onChange={evt =>
                              this.props.values?.includeFinancialContact === '0'
                                ? this.props.setValue('1', 'includeFinancialContact')
                                : this.props.setValue('0', 'includeFinancialContact')
                            }
                          /> */}
                        </div>

                        <VehicleCreateOrderField
                          invoicePage={this.props.invoicePage}
                          key={type}
                          type={type}
                          defaultFinancialContact={this.state.defaultFinContact}
                        />
                      </div>
                    );
                  }
                  return (
                    <VehicleCreateOrderField
                      invoicePage={this.props.invoicePage}
                      key={type}
                      type={type}
                      defaultFinancialContact={this.state.defaultFinContact}
                      showNewCompanyModal={this.openCustomerModal.bind(this)}
                    />
                  );
                })}
              <VBox>
                <div className={styles.checkboxContainer}>
                  <div className={styles.checkbox}>
                    {/* <CheckboxComponent
                      checked={this.props.values?.includeEmailContact === '1'}
                      onChange={evt =>
                        this.props.values?.includeEmailContact === '0'
                          ? this.props.setValue('1', 'includeEmailContact')
                          : this.props.setValue('0', 'includeEmailContact')
                      }
                    /> */}
                  </div>

                  <VBox>
                    <label className="form-label">{this.lbl(`vehicle.order.property.send_to_email`)}</label>

                    <div className={styles.card}>
                      {this.props.values?.email_contact && (
                        <div className={styles.labelCompany}>
                          <UserLabelById
                            order
                            user_id={this.props.values?.email_contact}
                            key={this.props.values?.email_contact}
                          />
                        </div>
                      )}

                      <ButtonComponent
                        style={'ButtonSoftPrimary'}
                        disabled={this.props.values?.includeEmailContact !== '1'}
                        onClick={() => this.setState({ selectUser: true })}
                      >
                        <EditSquare />
                      </ButtonComponent>
                    </div>
                    {this.renderAddUser()}
                  </VBox>
                </div>
                <VBox>
                  {['send_to_email'].map(type => (
                    <div className={styles.checkboxContainer}>
                      <div className={styles.checkbox}>
                        {/* <CheckboxComponent
                          checked={this.props.values?.includeManual === '1'}
                          onChange={evt =>
                            this.props.values?.includeManual === '0'
                              ? this.props.setValue('1', 'includeManual')
                              : this.props.setValue('0', 'includeManual')
                          }
                        /> */}
                      </div>

                      <VehicleCreateOrderField
                        invoicePage={this.props.invoicePage}
                        key={type}
                        type={type}
                        defaultEmail={this.state.companyEmail}
                      />
                    </div>
                  ))}
                </VBox>
              </VBox>
            </VBox>
            <div className={styles.buttonFooter}>
              <ButtonComponent
                style={'ButtonSoftDelete'}
                onClick={() => {
                  this.onResetValues();
                }}
              >
                {this.lbl(`cancel`)}
              </ButtonComponent>

              <ButtonComponent style="ButtonSoftPrimary" disabled={this.applyDisabled()} onClick={this.handleNextClick}>
                Next
              </ButtonComponent>
            </div>
          </ModalComponent>
        </Container>
      </>
    );
  }
}

SelectClientToOrderComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  reset: PropTypes.func,
  onNextModal: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    values: ownProps.invoicePage ? selectNewInvoice() : selectNewOrder(),
    work: selectWorks([REQUEST_COMPANY_ADD_USER, REQUEST_USER]),
    notification: selectNotification(),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchCompany(id, callback) {
      dispatch(fetchCompany(id, callback));
    },
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      ownProps.invoicePage ? dispatch(setNewInvoiceValue(name, value)) : dispatch(setNewOrderValue(name, value));
    },
    toggleNotification() {
      dispatch(toggleNotification('0'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const SelectClientToOrder = compose(withConnect, withRouter, injectIntl)(SelectClientToOrderComp);
